import React from "react";
import { useTranslation } from "react-i18next";

const HeroSection = () => {
      const { t } = useTranslation("about"); // Hook to use translations
    
    return (
        <div className="relative py-28 md:pt-[140px] px-5 sm:px-10 xl:pl-[140px] md:pb-[387px]">
            {/* Image Background */}
            <img
                src="/assets/abouthero.svg"
                className="w-full h-full object-cover absolute top-0 left-0"
                alt="background"
            />

            {/* <div className="absolute inset-0 bg-[#00000099]"></div>  */}

            {/* Content */}
            <div className="relative z-10 flex flex-col justify-start items-start sm:gap-5 container-class">
                <h1 className="web-heading-main text-2xl md:text-4xl">
                    {t("about_company")}
                </h1>
                <p className="text-color body-xl md:text-xl max-w-5xl py-[20px] text-sm max-w-[695px]">
                   {t("company_description")}
                </p>
            </div>
        </div>
    );
};

export default HeroSection;
